"use client";

/**
 * What the screen can be answered with, without lifting a hand.
 *
 * One line, and only when there is an instrument on the other end — see
 * `useHandsOnPiano`. Someone on the computer keyboard has `Entrée` under a
 * finger and does not need to be told about a pedal they do not have.
 *
 * The gesture is set as a key cap and the effect in prose, because that is the
 * order the player reads it in: they are looking for what to *do*, and the
 * answer is one word long.
 */

export type HandsOnGesture = {
  /** What the player does. One or two words, it is set as a cap. */
  readonly gesture: string;
  /** What it produces here. */
  readonly effect: string;
};

export function HandsOnHint({
  items,
}: {
  readonly items: readonly HandsOnGesture[];
}) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "4px 12px",
        marginTop: 10,
        fontSize: 11,
        lineHeight: 1.5,
        color: "var(--color-text-secondary)",
        opacity: 0.85,
      }}
    >
      {items.map((item) => (
        <span
          key={item.gesture}
          style={{ display: "inline-flex", alignItems: "center", gap: 5 }}
        >
          <span
            style={{
              padding: "1px 6px",
              borderRadius: 4,
              border: "1px solid var(--color-border-subtle)",
              color: "var(--color-text-primary)",
              fontSize: 10,
              whiteSpace: "nowrap",
            }}
          >
            {item.gesture}
          </span>
          {item.effect}
        </span>
      ))}
    </div>
  );
}
